import React, {useContext, useEffect, useState} from "react";
//import { ProfileContext } from "../ProfileContext";
import { errorMesg } from "../../../Toaster";
import { Modal, Button } from 'react-bootstrap';
import {UpdateBasicInfoAPI, getBasicProfileAPI} from "./../../../../API/Team/LeadAPI";

const BasicProfile = ({profiledata, profileid, onReload}) =>{

    //const {profiledata, profileid} = useContext(ProfileContext);

    const [isbasicinfomodal, setIsBasicInfoModal] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [contact, setContact] = useState("");
    const [location, setLocation] = useState("");
    const [program, setProgram] = useState("");
    const [institute, setInstitute] = useState("");
    const [isupdatebasicinfo, setIsUpdateBasicInfo] = useState(false);
    const [btnsubmitspin, setBtnSubmitSpin] = useState(false);

    const txtbasicinfomodalheader = "Update Lead Basic Info";

    //console.log('under basic profile=====' + JSON.stringify(profiledata));
    //console.log('under basic profile=====' + profiledata.name);
    //console.log('profile ID=====' + profileid);

    useEffect(()=>{
        console.log('Step 1 Info Data reloaded');
        setName(profiledata?.name || "");
        setEmail(profiledata?.email || "");
        setContact(profiledata?.contact || "");
        setLocation(profiledata?.location || "");
        setProgram(profiledata?.program || "");
        setInstitute(profiledata?.institute || "");

    }, [profileid]);


    /*useEffect(()=>{
        console.log('Basic Info Data reloaded');
        getBasicProfileAPI(setName, setEmail, setContact, setLocation, setProgram, setInstitute, profileid);

    }, [isupdatebasicinfo]);*/

    const handleBasicInfoModal = () =>{
		setIsBasicInfoModal(!isbasicinfomodal);
	}

    const handleBasicInfoModalHide = () =>{
        setIsBasicInfoModal(false);
    }

    const handleName = (e) =>{
        setName(e.target.value);
    }

    const handleEmail = (e) =>{
        setEmail(e.target.value);
    }

    const handleContact = (e) =>{
        setContact(e.target.value);
    }

    const handleLocation = (e) =>{
        setLocation(e.target.value);
    }

    const handleProgram = (e) =>{
        setProgram(e.target.value);
    }

    const handleInstitute = (e) =>{
        setInstitute(e.target.value);
    }

    const handleBasicInfoSubmit = () =>{

        console.log('Name====='+name);

        if(name === "")
        {
            errorMesg("Please enter name");
            return;
        }
        else if(email === "")
        {
            errorMesg("Please enter emaile");
            return;
        }
        else if(contact === "")
        {
            errorMesg("Please enter contact");
            return;
        }
        else if(location === "")
        {
            errorMesg("Please enter location");
            return;
        }
        else if(program === "")
        {
            errorMesg("Please enter program");
            return;
        }
        else if(institute === "")
        {
            errorMesg("Please enter institute");
            return;
        }
        else
        {
            const formData = new FormData();
            formData.append('leadid', profileid);
            formData.append('name', name);
            formData.append('email', email);
            formData.append('contact', contact);
            formData.append('location', location);
            formData.append('program', program);
            formData.append('institute', institute);            

            console.log('params data====' + formData);
            console.log('params data====' + formData.name);

            UpdateBasicInfoAPI(formData, setBtnSubmitSpin, setIsUpdateBasicInfo, setIsBasicInfoModal, onReload);

        }
    }

    /*if(!profiledata)
        return null;*/

    return(
    <>
        <button class="btn-none crm-card-edit-btn" onClick={handleBasicInfoModal}>
            <i class="fas fa-pencil"></i>
        </button>

        <div class="d-flex align-items-center crm-summary-inner">
            <div class="crm-lead-avatar me-3">SU</div>
            <div class="crm-summary-content">
                <h4 class="crm-lead-name mb-1">{name} <span class="text-warning">⭐</span></h4>
                <div class="crm-lead-meta-list">
                    <span><i class="ti ti-mail me-1"></i>{email}</span>
                    <span><i class="ti ti-phone-call me-1"></i>{contact}</span>
                    <span><i class="ti ti-map-pin-pin me-1"></i>{location}</span>
                    <span><i class="ti ti-gradienter me-1"></i>{program}</span>
                    <span><i class="fas fa-building me-1"></i>{institute}</span>
                </div>
            </div>
        </div>


        <Modal show={isbasicinfomodal} onHide={handleBasicInfoModalHide} centered>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">{txtbasicinfomodalheader}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <label className="col-form-label">Name
                        <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" value={name} onChange={handleName} />
                </div>
                <div className="mb-3">
                    <label className="col-form-label">Email
                        <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" value={email} onChange={handleEmail} />
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="col-form-label">Contact
                                <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="form-control" value={contact} onChange={handleContact} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="col-form-label">Location
                                <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="form-control" value={location} onChange={handleLocation} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="col-form-label">Program
                                <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="form-control" value={program} onChange={handleProgram} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="col-form-label">Institute
                                <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="form-control" value={institute} onChange={handleInstitute} />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleBasicInfoModalHide}>Close</button>

                {btnsubmitspin ?
                    <button type="button" class="btn btn-primary">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </button>
                :
                    <button type="button" class="btn btn-primary" onClick={handleBasicInfoSubmit}> Update Info </button>
                }
            </Modal.Footer>
        </Modal>
    </>
    );
}

export default BasicProfile;
